define('SuiteCommerce.ItemBadges.Configuration', [], function Configuration() {
  'use strict';

  return {
    environment: null,
    initialize: function initialize(application)
    {
      this.environment = application.getComponent('Environment');
    },

    get: function get(name) {
      if (this.environment) {
        return this.environment.getConfig(name);
      }
      return null;
    }
  }
});
